import { render, staticRenderFns } from "./TreatmentMonitoringWrapper.vue?vue&type=template&id=ccb4d898&scoped=true&"
import script from "./TreatmentMonitoringWrapper.vue?vue&type=script&lang=ts&"
export * from "./TreatmentMonitoringWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb4d898",
  null
  
)

export default component.exports